import { connect } from 'react-redux'
import {
  compose, withHandlers, lifecycle, withState,
} from 'recompose'
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import { clearCurrentUser } from 'actions/Auth'
import { updateSiteConfiguration } from 'actions/Site'
import history from 'utils/history'
import PrivateLayoutView from 'components/layouts/PrivateLayout'

let currentSite

export function mapStateToProps(state) {
  currentSite = state.root.site
  const { site } = state.root
  const { currentUser } = state.root.auth

  console.log("currentUser: ",currentUser)
  return {
    site,
    currentUser,
  }
}


const mapDispatchToProps = dispatch => ({
  clearCurrentUser: bindActionCreators(clearCurrentUser, dispatch),
  updateSiteConfiguration: bindActionCreators(updateSiteConfiguration, dispatch),
})

export default compose(
  withRouter,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withState('collapse', 'setCollapse', false),
  withHandlers({
    handleCollapse: props => () => {
      props.setCollapse(!props.collapse)
    },
    doLogout: props => () => {
      props.clearCurrentUser()
    },
    handleKeys: props => (param, isOpenSub) => {
      if (isOpenSub) {
        const latestOpenKey = param.find(key => currentSite.activeSubPage.indexOf(key) === -1)
        const rootSubmenuKeys = ['dashboard']
        if (rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
          props.updateSiteConfiguration('activeSubPage', param)
        } else {
          const key = latestOpenKey ? [latestOpenKey] : []
          props.updateSiteConfiguration('activeSubPage', key)
        }
        // props.updateSiteConfiguration('activeSubPage', last(param))
      } else {
        props.updateSiteConfiguration('activePage', param.keyPath[0])
        history.push(`/${param.keyPath[0]}`)
        if (param.keyPath.length > 1) {
          props.updateSiteConfiguration('activeSubPage', param.keyPath[param.keyPath.length - 1])
        } else {
          props.updateSiteConfiguration('activeSubPage', param.keyPath[0])
        }
      }
    },
  }),
  lifecycle({
    componentDidMount() {
      const { currentUser } = this.props
      if (!currentUser) {
        this.props.doLogout()
      }
    },
  }),
)(PrivateLayoutView)
